<template>
	<nk-wrapper v-if="context.brancheneintrag" spacing="md">
		<nk-meta
			v-if="
				context.brancheneintrag.spezialisierung && !options.hideSpecialization
			"
			variant="normal"
			size="base"
		>
			{{ context.brancheneintrag.spezialisierung }}
		</nk-meta>

		<nk-title v-if="context.brancheneintrag.titel" tag="h1" size="3xl">
			{{ context.brancheneintrag.titel }}
		</nk-title>

		<nk-image
			v-if="getBranchenImageKey(context.brancheneintrag, 'bild')"
			class="sm:ml-4 sm:float-right w-full sm:w-5/12 xl:max-w-xs"
			:src="getBranchenImageKey(context.brancheneintrag, 'bild')"
			:alt="getBranchenImageKey(context.brancheneintrag, 'bildtext')"
			:copyright="getBranchenImageKey(context.brancheneintrag, 'bildcopyright')"
			:caption="getBranchenImageKey(context.brancheneintrag, 'bildtext')"
			:lightbox="hasImageGallery ? 'bildergalerie' : true"
			:gallery="
				hasImageGallery
					? context.brancheneintrag.bildergalerie_zuordnung.bilder
					: []
			"
			:no-cache="true"
		/>

		<nk-wrapper
			v-if="context.brancheneintrag.rubriken && !options.hideCategory"
		>
			<nk-list variant="clean">
				<nk-list-item
					v-for="(rubrik, rubrikIndex) in context.brancheneintrag.rubriken"
					:key="`rubrik-${rubrikIndex}`"
					icon="library"
				>
					{{ rubrik.rubrik }}
				</nk-list-item>
			</nk-list>
		</nk-wrapper>

		<div
			v-if="context.brancheneintrag.text"
			class="nk-cms-content nk-cms-content--detail"
			v-html="context.brancheneintrag.text"
		/>

		<div
			v-if="context.brancheneintrag.text_gastronomie"
			class="nk-cms-content nk-cms-content--detail"
			v-html="context.brancheneintrag.text_gastronomie"
		/>

		<div class="clear-both" />
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {boolean} options.hideSpecialization
 * @prop {boolean} options.hideCategory
 * @prop {boolean} options.gastro
 */
export default {
	name: 'NkTemplateBrancheneintraegeDetail',

	mixins: [TemplatesDefault],

	computed: {
		hasImageGallery() {
			if (
				this.context.brancheneintrag &&
				this.context.brancheneintrag.bildergalerie_zuordnung &&
				this.context.brancheneintrag.bildergalerie_zuordnung.bilder.length
			) {
				return true;
			}
			return false;
		},
	},

	methods: {
		getBranchenImageKey(brancheneintrag, key) {
			if (this.options.gastro) {
				return brancheneintrag[`${key}2`];
			}
			return brancheneintrag[key];
		},
	},
};
</script>
